import {
  CampaignTypesKey,
  GlobalListPageKey,
  GlobalPageHeaderKey,
  TableTypesKey,
  UtilsTypesKey
} from 'utils/globalTranslation/TModules';

export const translations = {
  [GlobalListPageKey]: {
    RequestHasBeenApproved: 'Request has been approved',
    RequestHasBeenDeleted: 'Request has been deleted',
    RequestHasBeenDenied: 'Request has been denied',
    RequestHasBeenCancelled: 'Request has been cancelled',
    RequestsHaveBeenApproved: 'Requests have been approved',
    ThisFieldIsRequired: 'This field is required',
    SomethingWentWrong: 'Something Went Wrong!',
    Edit: 'Edit',
    Maker: 'Maker',
    Checker: 'Checker',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    NoData: 'No Data',
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Year: 'year',
    Days: 'days',
    Weeks: 'weeks',
    Months: 'months',
    Required: 'Required',
    MinValue: 'Must be positive value and {{min}}',
    MaxValue: 'Must not be more than {{max}}',
    MustBeInteger: 'Must be integer values',
    MustBeNumber: 'Must be a number',
    InvalidEmail: 'Invalid email address',
    InvalidUrl: 'Invalid Url',
    NotGreaterThanUserLimit: 'Value should not be greater than User Limit',
    NotGreaterThanRewardLimit: 'Value should not be greater than Reward Limit',
    ValueMustBePositive: 'Value should be positive',
    ValueMustBeMoreThanZero: 'Value should be more than zero',
    InvalidCsvXlsx: 'Only .xlsx/.csv files are accepted, you have uploaded an invalid file type.',
    OnlyImageTypes: 'You can only upload JPG/JPEG/PNG/SVG file!',
    SvgUnprocessable: 'SVG file is unprocessable!'
  },
  [GlobalPageHeaderKey]: {
    RewardRequest: 'Reward Request'
  },
  [CampaignTypesKey]: {
    AllCampaigns: 'All campaigns',
    InstantReward: 'Instant reward',
    Stamp: 'Stamp',
    Game: 'Game',
    Quiz: 'Quiz',
    Survey: 'Survey',
    Quest: 'Quest',
    Progress: 'Progress',
    Raffle: 'Raffle',
    Streak: 'Streak',
    AllGames: 'All games',
    SpinTheWheel: 'Spin The Wheel',
    ShakeTheTree: 'Shake The Tree',
    HitThePinata: 'Hit The Pinata',
    ScratchCard: 'Scratch Card',
    Plinko: 'Plinko',
    BubblePop: 'Bubble Pop',
    Reward: 'Reward',
    Referral: 'Referral',
    TeamProgress: 'Team progress',
    MultipleRuleCampaign: 'Multiple rule campaign',
    Generic: 'Generic',
    Campaign: 'Campaign',
    Points: 'Points',
    Cashback: 'Cashback',
    Voucher: 'Voucher',
    Batch: 'Batch',
    prize_set: 'prize_set',
    LoyaltyCurrency: 'Loyalty currency',
    Rewards: 'Rewards',
    Audience: 'Audience',
    UpdateCustomerDetails: 'Update customer details',
    PushEventOnly: 'Push Event Only'
  },
  [UtilsTypesKey]: {
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December'
  },
  [TableTypesKey]: {
    PerPage: '/ page',
    GoTo: 'Go to',
    Page: 'Page',
    PreviousPage: 'Previous Page',
    NextPage: 'Next Page',
    NoData: 'No Data'
  }
};
